import Sidebar from "../Sidebar/sidebar.css"
import { Link } from "react-router-dom";
import { getUserRole } from "../../utils/auth";
 import React, { useState, useEffect } from "react";
import {
  FiBarChart2,
  FiFileText,
  FiUsers,
  FiUserPlus,
  FiSettings,
  FiChevronLeft,
  FiChevronRight,
} from "react-icons/fi";

import { useLocation } from "react-router-dom";
// importing images
// import dashboard from "../../assets/images/dashboard.png";
// import reporting from "../../assets/images/reporting.png";
import logo from "../../assets/images/logo.png";  
// import logoWhite from "../../assets/images/logo-light.png"; 
// import icon from "../../assets/images/logo-icon.png";
const SidebarToggle = ({
  sidebarCollapsed,
  setSidebarCollapsed,
}) => {
  const pubId = localStorage.getItem("account_id");
  const role = getUserRole();
  
  const [activeIndex, setActiveIndex] = useState(null);
  // const [isOpen, setIsOpen] = useState(false);

  // const toggleSidebar = () => {
  //   setIsOpen(!isOpen);
  // };
  const location = useLocation();

  const menuItems = (role === "admin" || role === "ad_ops" || role === "account_manager" ) ? 
  [
    ...(role !== "account_manager" ? 
    [
      { name: "Add Publisher", path: "/add-publisher", icon: <FiUserPlus /> }, 
      { name: "Publisher list", path: "/publisher-list", icon: <FiUsers />}, 
    ] : []),
    { name: "All Reportings", path: "/admin-reporting", icon: <FiFileText />}
  ] : 
  [
    ...(pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3"
      ? [{ name: "Dashboard", path: "/summary", icon: <FiBarChart2 /> }]
      : []),
    { name: "Reporting", path: "/reporting", icon: <FiFileText /> },
    ...(pubId === "789cfdb0-ad79-4bf2-b244-6f883a99379f"
      ? [{ name: "Manage Ad", path: `/manage-ad/${pubId}`, icon: <FiSettings /> }]
      : [])
  ];
 

  useEffect(() => {
    // Find the active menu item based on current URL
    const currentIndex = menuItems.findIndex((sideBarItems) => sideBarItems.path === location.pathname);
    if (currentIndex !== -1) {
      setActiveIndex(currentIndex);
    }
  }, [location.pathname]);

  // // Hide sidebar on login page
  if (location.pathname === "/") {
    return null;
  }
  if (location.pathname === "/admin") {
    return null;
  }
  return (
      //     <aside className="sidebar">
      //       {/* <button type="button" className="sidebar-close-btn">
      //         <iconify-icon icon="radix-icons:cross-2"></iconify-icon>
      //       </button> */}
      //   <div className="sidebar-logo">
      //     {/* <Link to="" className="sidebar-logo"> */}
      //       <img src={logo} alt="site logo" className="light-logo" />
      //       {/* <img src={logoWhite} alt="site logo" className="dark-logo" /> */}
      //       {/* <img src={icon} alt="site logo" className="logo-icon" /> */}
      //     {/* </Link> */}
      //   </div>
      //   <div className="sidebar-menu-area open">
      //     <ul className="sidebar-menu show" id="sidebar-menu">
      //     {
      //       menuItems.map((sideBarItems, sideBarItemsInd) =>(
      //           <li key={sideBarItemsInd} className={activeIndex === sideBarItemsInd ? "active" : ""} onClick={()=>setActiveIndex(sideBarItemsInd)}>
      //           <Link to={sideBarItems.path}>
      //             <img src={sideBarItems.image} className="menu-icon" />
      //             <span>{sideBarItems.name}</span>
      //           </Link>
      //         </li>
      //       ))
      //     }  
      //       {/* <li className="active-page">
      //             <Link to="/Reporting" className="active-page">
      //             <img src={reporting} className="menu-icon" /> Reporting</Link>
      //       </li>  */}
      //     </ul>
      //   </div>
      // </aside>
    // new layout 
    <aside className={`sidebar ${
        sidebarCollapsed ? "sidebar-collapsed" : ""
      }`}>
      {/* Logo */}
      <div className="sidebar-logo">
        <Link to={role === "publisher" ? "/summary" : "/admin-reporting"}>
          <img src={logo} alt="Adchronix" className="sidebar-logo-image" />
        </Link>
      </div>
      {/* toggle button  */}
      <button
        type="button"
        className="sidebar-toggle-button"
        onClick={() =>
          setSidebarCollapsed(!sidebarCollapsed)
        }
        aria-label={
          sidebarCollapsed
            ? "Expand sidebar"
            : "Collapse sidebar"
        }
      >

        {sidebarCollapsed ? (
          <FiChevronRight />
        ) : (
          <FiChevronLeft />
        )}

      </button>

      {/* Menu */}
      <div className="sidebar-menu-area">
        <ul className="sidebar-menu">
          {menuItems.map((item, index) => (
            <li
              key={item.path}
              className={activeIndex === index ? "active" : ""}
              onClick={() => setActiveIndex(index)}
            >
              <Link to={item.path}>
                <span className="menu-icon">
                  {item.icon}
                </span>

                <span className="menu-text">
                  {item.name}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SidebarToggle;
